import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGNATURES_DISTRIBUTION_CONFIG = createFcmDetails('signatures_distribution_config', {
	owner: 'Campaign Squad',
	context: 'Controls roll-out for /p/:slug, displaying signatures distribution',
	description: /* TODO */ '',
	import: false,
	template: {
		activatedPercentage: 0,
		createdAfter: '2015-0101',
		minSignaturePercentageToBeACluster: 0.6,
		signatureCount: {
			minimum: 100,
			maximum: 50000,
		},
		clusterSearch: {
			minimumSize: 0.1,
			increment: 0.1,
			maximumSize: 0.4,
		},
		petitions: [{ petitionId: '42', clusterSize: 0.5, zoomLevel: 8, minSignaturePercentageToBeACluster: 0.7 }],
		blocklist: [{ petitionId: '66' }],
	},
});
